export interface XsollaPaymentInfo {
  status: string;
  foreignInvoice: string;
  invoice_id: string;
}

export type PurchaseErrorStatus = 'cancelled' | 'failed' | 'closed';

export class SubscriptionRedirected extends Error {}

export class XsollaPaymentError extends Error {
  status: PurchaseErrorStatus;
  constructor(status: PurchaseErrorStatus) {
    super();
    this.status = status;
  }
}
